import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import {
    fetchFICReportThunk,
    updateFICReportThunk,
} from "./reportsThunk";


export enum ReportStatus {
    SUBMITTED = "SUBMITTED",
    IN_PROGRESS = "IN_PROGRESS",
    AVAILABLE = "AVAILABLE",
    FAILED = "FAILED",
}

interface FICReportState {
    status: 'idle' | 'loading' | 'saving' | 'load_failed' | 'save_failed';
    review_committee_remarks: string;
    fraud_classification: string;
    report_status?: ReportStatus;
}


const initialFICReportState: FICReportState = {
    status: 'idle',
    review_committee_remarks: "",
    fraud_classification: "",
    report_status: undefined
} 


export interface ReportsState {
    caseId: string | null;
    fic: FICReportState;
}

const initialReportsState: ReportsState = {
    caseId: null,
    fic: initialFICReportState,
}

const reportsSlice = createSlice({
    name: "reports",
    initialState: initialReportsState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchFICReportThunk.fulfilled, (state, action) => {
                state.caseId = action.meta.arg.case_id;
                state.fic.fraud_classification = action.payload.fraud_classification
                state.fic.review_committee_remarks = action.payload.review_committee_remarks
                state.fic.report_status = action.payload.status
                state.fic.status = 'idle';
            })
            .addCase(fetchFICReportThunk.rejected, (state) => {
                state.fic.status = 'load_failed';
        
            })
            .addCase(fetchFICReportThunk.pending, (state) => {
                state.fic = {
                    ...initialFICReportState,
                    status: 'loading',
                };
            })            
            .addCase(updateFICReportThunk.fulfilled, (state, {meta}) => {
                state.fic.fraud_classification = meta.arg.request.fraud_classification
                state.fic.review_committee_remarks = meta.arg.request.review_committee_remarks
                state.fic.status = 'idle';
            })
            .addCase(updateFICReportThunk.rejected, (state) => {
                state.fic.status = 'save_failed';
            })
            .addCase(updateFICReportThunk.pending, (state) => {
                state.fic.status = 'saving';
            })                           
    }
})


export const reportsReducer = reportsSlice.reducer;


export const selectFICReportState = (state: RootState) => state.reportsData.fic

